import { Product } from '../../models/product';
import { SocialMetadataFactory } from '../../components/PageSpecificMetadata/SocialMetadata';
import { minimizeCharactersCount, removeHtmlTags } from '../seoHelper';

interface ProductDetailSocialMetadataFactoryProps {
  product: Product;
}

export const getSocialTitle = ({ brand, model }: Product) =>
  `Best price on the market at italist | ${brand.name} ${model}`;

const socialMetadataFactory = ({
  product,
}: ProductDetailSocialMetadataFactoryProps): ReturnType<typeof SocialMetadataFactory> => {
  const {
    description,
    images,
    price: { currency, reducedAfterTax },
  } = product;

  return SocialMetadataFactory({
    currency,
    overrideDescription: minimizeCharactersCount(removeHtmlTags(description), 160),
    overrideImages: images.map(img => ({ height: 520, url: img.medium, width: 390 })),
    overrideTitle: getSocialTitle(product),
    overrideType: 'og:product',
    price: reducedAfterTax / 100.0,
  });
};

const productDetail = {
  descriptionFactory: ({ model }: Product) => `Shop ${model} and save up to 40%. EXPRESS international shipping!`,
  socialMetadataFactory,
  titleFactory: ({ brand: { name: brandName }, model }: Product) => {
    const productName = model.toLowerCase().indexOf(brandName.toLowerCase()) > -1 ? model : `${brandName} ${model}`;
    if (productName.length > 40) {
      return `${productName} | italist`;
    }
    return `${productName} | italist, ALWAYS LIKE A SALE`;
  },
};

export default productDetail;
